import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0db90a15&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0db90a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db90a15",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Multimedia: require('/var/www/html/fantini/frontend-2/components/multimedia/index.vue').default,Btn: require('/var/www/html/fantini/frontend-2/components/btn/index.vue').default,VectorIcon: require('/var/www/html/fantini/frontend-2/components/vector/icon/index.vue').default,BtnPill: require('/var/www/html/fantini/frontend-2/components/btn/pill/index.vue').default,DetailsProduct: require('/var/www/html/fantini/frontend-2/components/details/product/index.vue').default,VectorCollection: require('/var/www/html/fantini/frontend-2/components/vector/collection/index.vue').default,GridCss: require('/var/www/html/fantini/frontend-2/components/grid/css/index.vue').default,ModalCreateList: require('/var/www/html/fantini/frontend-2/components/modal/create-list/index.vue').default,ModalNeedsUser: require('/var/www/html/fantini/frontend-2/components/modal/needs-user/index.vue').default,Block: require('/var/www/html/fantini/frontend-2/components/block/index.vue').default})
